// test1847
(1847 && 0);
